export const ReconciliationIconV2 = ({ width = 46 }) => {
  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 67 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" fill="white" />
      <rect x="1" y="0.5" width="65" height="65" rx="32.5" stroke="#916CF1" />
      <path
        d="M31.0762 19.909H40.2884M31.0762 26.6969H40.2884M31.0762 33.4847C33.6324 33.4847 40.5308 33.4847 40.5308 33.4847M20.4096 47.0605H40.7732C42.6477 47.0605 44.1671 45.541 44.1671 43.6665V16.515C44.1671 14.6406 42.6477 13.1211 40.7732 13.1211H20.4096C18.5351 13.1211 17.0156 14.6406 17.0156 16.515V43.6665C17.0156 45.541 18.5351 47.0605 20.4096 47.0605Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1367 19.9091L22.5913 21.3637L25.5004 18.4546"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6211 28.8783L25.015 25.4844M21.6211 25.4844L25.015 28.8783L21.6211 25.4844Z"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.1367 35.182L22.5913 37.0001L25.5004 33.3638"
        stroke="#15112D"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="25.2725"
        y="26.2271"
        width="29.5455"
        height="29.5455"
        rx="14.7727"
        fill="white"
      />
      <rect
        x="25.2725"
        y="26.2271"
        width="29.5455"
        height="29.5455"
        rx="14.7727"
        stroke="url(#paint0_linear_8254_28346)"
      />
      <g clipPath="url(#clip0_8254_28346)">
        <path
          d="M44.2632 38.8843L36.2344 34.2544"
          stroke="url(#paint1_linear_8254_28346)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M48.2783 44.7721V37.6354C48.278 37.3225 48.1954 37.0152 48.0388 36.7443C47.8823 36.4734 47.6572 36.2485 47.3862 36.0921L41.1416 32.5237C40.8704 32.3671 40.5627 32.2847 40.2495 32.2847C39.9363 32.2847 39.6287 32.3671 39.3574 32.5237L33.1128 36.0921C32.8418 36.2485 32.6168 36.4734 32.4602 36.7443C32.3036 37.0152 32.221 37.3225 32.2207 37.6354V44.7721C32.221 45.085 32.3036 45.3923 32.4602 45.6632C32.6168 45.934 32.8418 46.159 33.1128 46.3154L39.3574 49.8838C39.6287 50.0404 39.9363 50.1228 40.2495 50.1228C40.5627 50.1228 40.8704 50.0404 41.1416 49.8838L47.3862 46.3154C47.6572 46.159 47.8823 45.934 48.0388 45.6632C48.1954 45.3923 48.278 45.085 48.2783 44.7721Z"
          stroke="url(#paint2_linear_8254_28346)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.4609 36.7075L40.2489 41.2126L48.0368 36.7075"
          stroke="url(#paint3_linear_8254_28346)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.249 50.1959V41.2036"
          stroke="url(#paint4_linear_8254_28346)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_8254_28346"
          x1="40.0452"
          y1="25.7271"
          x2="40.0452"
          y2="56.2725"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A01A" />
          <stop offset="1" stopColor="#7647EE" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_8254_28346"
          x1="40.2488"
          y1="34.2544"
          x2="40.2488"
          y2="38.8843"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A01A" />
          <stop offset="1" stopColor="#7647EE" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_8254_28346"
          x1="40.2495"
          y1="32.2847"
          x2="40.2495"
          y2="50.1228"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A01A" />
          <stop offset="1" stopColor="#7647EE" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_8254_28346"
          x1="40.2489"
          y1="36.7075"
          x2="40.2489"
          y2="41.2126"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A01A" />
          <stop offset="1" stopColor="#7647EE" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_8254_28346"
          x1="40.749"
          y1="41.2036"
          x2="40.749"
          y2="50.1959"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9A01A" />
          <stop offset="1" stopColor="#7647EE" />
        </linearGradient>
        <clipPath id="clip0_8254_28346">
          <rect
            width="21.4102"
            height="21.4102"
            fill="white"
            transform="translate(29.5439 30.4985)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
